import { useIsMobile } from '@/components/form';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { CalendarSelectSheet } from '@/domain/termine/features/UpdateTermin/Desktop/components/CalendarSelectSheet';
import { CalendarSelectDrawer } from '@/domain/termine/features/UpdateTermin/Mobile/components/CalendarSelectDrawer';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';

export function CalendarSelectFormField({ form }: UpdateTermineFormProps) {
  const isMobile = useIsMobile();
  const { kalender } = useCalendarContext();

  return (
    <>
      {isMobile ? (
        <CalendarSelectDrawer kalender={kalender} form={form} />
      ) : (
        <CalendarSelectSheet kalender={kalender} form={form} />
      )}
    </>
  );
}
